import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getLearningPathLessonQuizzes } from "../../../api/endpoints/LearningPathEndpoints";
import { Paged } from "../../../models/Paged";
import { Quiz } from "../../../models/Quiz";

export default function useGetLearningPathLessonQuizzesPaginated(
  learningPathId: string,
  lessonId: string,
) {
  return useMutation<Paged<Quiz>, AxiosError, { page: number }>({
    mutationKey: ["quizzes"],
    mutationFn: ({ page }) =>
      getLearningPathLessonQuizzes(learningPathId, lessonId, page),
  });
}
